<template>
  <div>
    <MainHeader />
    <div
      class="empty-list">
      <div class="null-infor-list">
        <div class="content-flag">
          <div class="common-empty">
            <img src="@/assets/img/404.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted,ref } from "vue";
import MainHeader from "@/components/main-header.vue";
import { useHead } from "@vueuse/head";


const SSRData = ref({
  title: "找不到页面",
  description: "",
  keywords:"宁波技术社区,默认代码,程序员中文技术社区,前端开发社区,前端技术交流,前端框架教程",
});

onMounted(async () => {
    setSSRHead();
});

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};
</script>

<style scoped>
/*404 界面 */
.empty-list {
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  background: #fff;
  min-width: 800px;
  min-height: 725px;
}
.null-infor-list {
  font-size: 16px;
  line-height: 26px;
  padding: 10px 0 20px;
  margin-top: 51px;
}
.content-flag {
  font-size: 16px;
  font-weight: 400;
  color: #8a919f;
  margin-top: 50px;
}
.common-empty {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
</style>
